import React from 'react';
import CommonBanner from "../component/Common/CommonBanner";
import { ImageConstants } from "../assets/img/ImageConstants";
import BookYourTravel from '../component/BookYourTravel';
import StaticSEOTags from '../component/DynamicSEO/StaticSEOTags';
import Img from "../assets/img/imagination/imagination1.png";
const VisaConsultation = () => {
  return (
    <>
      <StaticSEOTags
        fallbackTitle="Pakistan's Leading Travel Agency | Polifly Travels"
        fallbackDescription="Discover unforgettable journeys with Polifly Travels. The leading travel agency in Karachi, Pakistan, dedicated to making every trip extraordinary."
        fallbackKeywords="Polifly Travels"
        fallbackOgTitle="Pakistan's Leading Travel Agency | Polifly Travels"
        fallbackOgDescription="Discover unforgettable journeys with Polifly Travels. The leading travel agency in Karachi, Pakistan, dedicated to making every trip extraordinary."
        fallbackCanonicalUrl="https://poliflytravels.com/"
      />
      <CommonBanner
        heading="Visa Consultation"
        img={ImageConstants.visabanner}
        pagination="Visa Consultation"
      />

      {/* Main Content Section */}
      <section className="visa-consultation-area pt-20 pb-5 mt-20 ">
        <div className="container pt-5 pb-5">
          <div className="row">
            <div className="col-lg-6">
              <div className="visa-content">
                <h2 className="mb-4">Polani Travels – Your Trusted Partner for Visa Consultation in Pakistan</h2>

                <div className="intro-section mb-5">
                  <p className="lead">
                    Planning a trip but overwhelmed by visa formalities? Let Polani Travels handle the hassle for you!
                  </p>
                  <p>
                    We offer expert visa consultation services, making your application process smooth, quick, and stress-free.
                  </p>
                </div>

                <div className="professional-assistance mb-5">
                  <h3 className="mb-3">Professional Visa Assistance for a Seamless Journey</h3>
                  <p>
                    Whether you're applying for a tourist visa, business visa, or visiting family abroad, our experienced consultants are here to guide you — from document preparation to application submission and status tracking.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
            <img src={Img} alt="img" />
            </div>
            </div>
          <div className="row pt-5">
            <div className="col-md-6">
              <div className="destinations-section mb-5">
                <h3 className="mb-4">Visa Services for Popular Global Destinations</h3>
                <p className="mb-3">We provide visa assistance for multiple countries, including:</p>

                <ul className="benefits-list">
                  <li>UAE</li>
                  <li>Turkey</li>
                  <li>Schengen States</li>


                  <li>USA & Canada</li>
                  <li>UK, Australia, Malaysia, Thailand</li>
                  <li>Saudi Arabia & Middle East regions</li>
                </ul>


              </div>
            </div>

            <div className="col-md-6">
              <div className="why-choose-section mb-5">
                <h3 className="mb-4">Why Choose Polani Travels for Visa Services?</h3>
                <ul className="benefits-list">
                  <li>Personalized consultation based on your travel purpose</li>
                  <li>Clear, transparent process with no hidden costs</li>
                  <li>Expert document review with high approval rates</li>
                  <li>Help with hotel bookings, flight reservations & travel insurance (if required)</li>
                  <li>Fast processing and timely follow-ups</li>
                </ul>
              </div>
            </div> </div>
          <div className="cta-section mb-5">
            <h3 className="mb-3">Begin Your Visa Application Today</h3>
            <p className="mb-4">
              Avoid the stress of paperwork, embassy queues, and online confusion. With Polani Travels, your visa journey is simplified from start to finish.
            </p>
            <div className="contact-info">
              <p className="mb-2">
                📞 Call us now or fill out our online form — our visa experts will get in touch with the perfect plan for your next adventure.
              </p>
              <div className="contact-buttons">
                <a href="tel:+02132410444" className="btn btn-primary me-3">
                  Call Now: (021) 32410444
                </a>
                <a href="/contact-us/" className="btn btn-outline-primary">
                  Contact Form
                </a>
              </div>
            </div>
          </div>



        </div>

      </section>

      {/* <BookYourTravel /> */}
    </>
  );
};

export default VisaConsultation; 